<template>
    <div>
        <button class='swb-btn swb-btn-small mb10 fr' @click="getXMsgList();">刷新</button>
        <div class="table-layout">
            <el-table ref="multipleTable" :data="xMsgList" border tooltip-effect="dark" style="width: 100%">
                <el-table-column align="left" prop="txt" label="标题" show-overflow-tooltip></el-table-column>
                <el-table-column align="left" label="内容" show-overflow-tooltip>
                    <template slot-scope="rows">
                        <span v-if="rows.row.data != null && rows.row.data.indexOf('{') >= 0">{{ JSON.decode(rows.row.data).message }}</span>
                        <span v-else>{{rows.row.data}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="sendTime" width="200" label="发送时间" show-overflow-tooltip></el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import comnApi from '../../api/comn'

    export default{
        name: 'swb-voucher-msg-list',
        desc: '站点信',
        props: {
            group: {
                type: String
            },
            fieldx: {
                type: String
            },
            fieldy: {
                type: String
            },
        },
        data: function () {
            return {
                xMsgList: []
            }
        },
        created: function () {
            this.getXMsgList();
        },
        methods: {
            getXMsgList: function () {
                let self = this;
                let postData = {};
                postData.group = self.group;
                postData.fieldx = self.fieldx;
                postData.fieldy = self.fieldy;
                let theLoad = MsgBox.loading();
                comnApi.getSendMsgList(postData, function (result) {
                    if(result.type == 'info') {
                        let xMsgList = result.data;
                        self.xMsgList = Utils.merge({}, xMsgList);
                    } else {
                        MsgBox.warning(result.message);
                    }
                    theLoad.hide();
                });
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/msg/VoucherMsgList.vue